import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* get({ payload: { companyId } }) {
  try {
    const { data } = yield call(dataProvider.getList, `companies/${companyId}/owner-working-hours/questions`, {});
    yield put({
      type: currentCompany.ownerWorkingHoursQuestions.get.end,
      payload: { list: data },
    });
  } catch (e) {
    yield put({ type: notification.add, payload: { error: e.message } });
    yield put({ type: currentCompany.ownerWorkingHoursQuestions.get.error });
  }
}

export default function* getWorkingHoursQuestionsSaga() {
  yield takeLatest(currentCompany.ownerWorkingHoursQuestions.get.start, get);
}
